const getters = {
  currentCart(state) {
    return state.currentCart;
  },
  addonProducts(state) {
    return state.addonProducts;
  },
  boxProducts(state){
    return state.mainProducts;
  },
  cardProducts(state){
    return state.cardProducts;
  },
  feeProduct(state){
    return state.feeProduct;
  },
};

export default getters;
